import type { TOC } from '@ember/component/template-only';
import { PrismCheckbox, PrismIcon } from '@mylighthouse/prism-ember';

type ProductAccessState = 'checked' | 'unchecked' | 'readonly' | 'unavailable';

interface SettingsUsersTablesCellsCellProductAccessSignature {
  Args: {
    cellData: ProductAccessState;
    row: {
      isDisabled?: boolean;
    };
  };
}

const CellProductAccess = <template>
  <div>
    {{#if (isCheckbox @cellData)}}
      <PrismCheckbox
        @checked={{isChecked @cellData}}
        @disabled={{@row.isDisabled}}
        data-test-id="cell-product-access-checkbox"
      />
    {{else if (isReadonly @cellData)}}
      <PrismIcon
        @name="checkmark"
        @size="small"
        data-test-id="cell-product-access-icon"
      />
    {{else}}
      <PrismIcon
        @name="cross"
        @size="small"
        data-test-id="cell-product-access-icon"
      />
    {{/if}}
  </div>
</template> satisfies TOC<SettingsUsersTablesCellsCellProductAccessSignature>;

function isCheckbox(state: ProductAccessState): boolean {
  return state === 'checked' || state === 'unchecked';
}

function isChecked(state: ProductAccessState): boolean {
  return state === 'checked';
}

function isReadonly(state: ProductAccessState): boolean {
  return state === 'readonly';
}

export default CellProductAccess;
